import { DOMAIN_COUNTRY_MAP } from '@/src/constants/domain'

/**
 * Maps hostname to GTM page_country code
 * @param hostname - The hostname from window.location.hostname
 * @returns GTM country code ('global', 'eg', 'ae')
 */
export const getGtmPageCountry = (hostname: string): string => {
    if (!hostname) return 'global'

    const origin = `https://${hostname.toLowerCase()}`
    const countryCode = DOMAIN_COUNTRY_MAP[origin as keyof typeof DOMAIN_COUNTRY_MAP]

    return countryCode === 'FSA' ? 'global' : countryCode === 'FEG' ? 'eg' : countryCode === 'FAE' ? 'ae' : 'global'
}

